import styled from 'styled-components';

import { Row as RawRow } from 'components/shared/Layout';

const StyledCostRow = styled(RawRow)`
  p {
    margin: 0;
  }
`;

const StyledAmount = styled.div`
  text-align: left;
`;

const StyledAlertWrapper = styled.div`
  margin-top: 16px;
`;

const StyledAlertParagraph = styled.div`
  & + & {
    margin-top: 8px;
  }
`;

export { StyledAmount, StyledCostRow, StyledAlertWrapper, StyledAlertParagraph };
